import { LoadingScreen } from '@growtherapy/sprout-ui';

export function WhiteboardLoader() {
  return (
    <div className='relative w-full h-full order-2 sm:order-1 sm:mr-2 mt-2 sm:mt-0 rounded-2xl min-h-[250px] bg-neutral-100'>
      <LoadingScreen />
    </div>
  );
}
